import { render } from "./searchfield.vue?vue&type=template&id=1c623648&scoped=true"
import script from "./searchfield.vue?vue&type=script&lang=js"
export * from "./searchfield.vue?vue&type=script&lang=js"

import "./searchfield.vue?vue&type=style&index=0&id=1c623648&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c623648"]])

export default __exports__